import React from 'react';

import { useIntl } from '@edx/frontend-platform/i18n';
import { AppContext } from '@edx/frontend-platform/react';
import { Button, Dropdown } from '@openedx/paragon';
import jwtEncode from 'jwt-encode';

import urls from 'data/services/lms/urls';
import { get } from 'data/services/lms/utils';

import './ExpandedHeader.scss';
import { Link } from 'react-router-dom';
import AuthenticatedUserDropdown from './AuthenticatedUserDropdown';
import { useIsCollapsed } from '../hooks';
import messages from '../messages';
import BrandLogo from '../BrandLogo';

const AFFILIATE_SECRET_KEY = ',fx%26]E?9j38:B;E,?;_3\')5r3/e{x%';
const RENEW_SECRET_KEY = `97XRE4[T2?"d_%BWFmzR@p='Gi1=:ZVj^50<n(.l=j#_F]cG4Y`;
const USER_ORGANIZATION_URL = '/alnafi/api/user-organization/';
const STUDY_GUIDES_NAV_URL = '/alnafi/study-guides/';
const RENEW_URL = 'http://stage.alnafi.cloud/cart';
const TARGET_ORGANIZATION = 'riphah';
const AFFILIATE_SSO_URL = 'https://pitstop.alnafi.com/';

export const ExpandedHeader = () => {
  const { formatMessage } = useIntl();
  const { authenticatedUser } = React.useContext(AppContext);
  const isCollapsed = useIsCollapsed();
  const [showRenewButton, setShowRenewButton] = React.useState(false);
  const [studyGuides, setStudyGuides] = React.useState([]);

  React.useEffect(() => {
    let isMounted = true;

    const fetchUserOrganization = async () => {
      if (!authenticatedUser) {
        if (isMounted) {
          setShowRenewButton(false);
        }
        return;
      }

      try {
        const response = await get(urls.baseAppUrl(USER_ORGANIZATION_URL));
        const organization = response?.data?.organization?.trim()?.toLowerCase();
        if (isMounted) {
          setShowRenewButton(organization === TARGET_ORGANIZATION);
        }
      } catch (error) {
        if (isMounted) {
          setShowRenewButton(false);
        }
      }
    };

    fetchUserOrganization();

    return () => {
      isMounted = false;
    };
  }, [authenticatedUser]);

  React.useEffect(() => {
    let isMounted = true;

    const fetchStudyGuides = async () => {
      if (!authenticatedUser) {
        if (isMounted) {
          setStudyGuides([]);
        }
        return;
      }

      try {
        const response = await get(urls.baseAppUrl(STUDY_GUIDES_NAV_URL));
        if (isMounted) {
          setStudyGuides(response?.data?.results  || []);
        }
      } catch (error) {
        if (isMounted) {
          setStudyGuides([]);
        }
      }
    };

    fetchStudyGuides();

    return () => {
      isMounted = false;
    };
  }, [authenticatedUser]);

  const handleAffiliateRedirect = () => {
    if (!authenticatedUser) {
      console.error('No authenticated user found');
      return;
    }

    try {
      const payload = {
        email: authenticatedUser.email,
        username: authenticatedUser.username,
        iat: Math.floor(Date.now() / 1000),
        exp: Math.floor(Date.now() / 1000) + (60 * 60),
      };

      const token = jwtEncode(payload, AFFILIATE_SECRET_KEY);
      const redirectUrl = `${AFFILIATE_SSO_URL}?token=${token}`;
      window.open(redirectUrl, '_blank');
    } catch (error) {
      console.error('Error generating JWT token:', error);
    }
  };
  const handlecifredirect = () => {
    if (!authenticatedUser) {
      console.error('No authenticated user found');
      return;
    }
    const redirectUrl = 'https://alnafi.cloud/cif-domains';
    window.open(redirectUrl, '_blank');
  };

  const handlejobsredirect = () => {
    if (!authenticatedUser) {
      console.error('No authenticated user found');
      return;
    }
    const redirectUrl = 'https://jobportal.alnafi.com/';
    window.open(redirectUrl, '_blank');
  };
  const handlestudentservicesredirect = () => {
    if (!authenticatedUser) {
      console.error('No authenticated user found');
      return;
    }
    const redirectUrl = 'https://alnafi.com/services';
    window.open(redirectUrl, '_blank');
  };
  const handleRenewRedirect = () => {
    if (!authenticatedUser?.email) {
      console.error('No authenticated user found');
      return;
    }

    try {
      const now = Math.floor(Date.now() / 1000);
      const payload = {
        email: String(authenticatedUser.email).trim().toLowerCase(),
        iat: now,
        exp: now + (60 * 60),
      };

      const token = jwtEncode(payload, RENEW_SECRET_KEY);
      const redirectUrl = `${RENEW_URL}?token=${encodeURIComponent(token)}`;
      window.open(redirectUrl, '_blank', 'noopener,noreferrer');
    } catch (error) {
      console.error('Error generating renew token:', error);
    }
  };

  if (isCollapsed) {
    return null;
  }
console.log('Study Guides:', studyGuides); // Debugging line to check the fetched study guides
  return (
    <header className="d-flex shadow-sm align-items-center learner-variant-header pl-4">
      <div className="flex-grow-1 d-flex align-items-center">
        <BrandLogo />
        {/* <Dropdown className="custom-study-guides-dropdown">
          <Dropdown.Toggle className="btn btn-primary">
            Study Guides
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {studyGuides.length === 0 && (
              <Dropdown.Item disabled>No study guides available</Dropdown.Item>
            )}
            {studyGuides.map((guide) => (
              <Dropdown.Item
                key={guide.slug}
                as={Link}
                to={`study-guide/${guide.slug}`}
              >
                {guide.title}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown> */}
        <Button
          as="a"
          href="/learner-dashboard/"
          variant="inverse-primary"
          className="p-4 course-link"
        >
          {formatMessage(messages.course)}
        </Button>
        <Button
          onClick={handleAffiliateRedirect}
          variant="inverse-primary"
          className="p-4"
        >
          Build Your Profile
        </Button>
        <Button
          onClick={handlecifredirect}
          variant="inverse-primary"
          className="p-4"
        >
          Explore New Specializations
        </Button>
        <Button
          onClick={handlejobsredirect}
          variant="inverse-primary"
          className="p-4"
        >
          Find Jobs
        </Button>
        <Button
          onClick={handlestudentservicesredirect}
          variant="inverse-primary"
          className="p-4"
        >
          Student Services
        </Button>
        <span className="flex-grow-1" />
        {/* {showRenewButton && ( 
          <Button
            onClick={handleRenewRedirect}
            className="btn btn-primary mr-3"
          >
            Pay Renewal Fee
          </Button>
        )} */}
      </div>
      <AuthenticatedUserDropdown />
    </header>
  );
};

ExpandedHeader.propTypes = {};

export default ExpandedHeader;